// API Configuration Constants

// Amadeus API Configuration
export const AMADEUS_API = {
  CLIENT_ID: 'rgbQ73Seeiuqh83Pi8YUVTKrIpyqwOxU',
  CLIENT_SECRET: 'OsyYtX3MhGzbI41d',
  TOKEN_URL: 'https://test.api.amadeus.com/v1/security/oauth2/token',
  FLIGHT_SEARCH_URL: 'https://test.api.amadeus.com/v2/shopping/flight-offers',
  FLIGHT_PRICING_URL: 'https://test.api.amadeus.com/v1/shopping/flight-offers/pricing',
  AIRPORT_FACILITIES_URL: 'https://test.api.amadeus.com/v1/airport/direct-destinations/{airportCode}',
  FLIGHT_STATUS_URL: 'https://test.api.amadeus.com/v2/schedule/flights',
  HOTEL_SEARCH_URL: 'https://test.api.amadeus.com/v1/reference-data/locations/hotels/by-city',
  HOTEL_OFFERS_URL: 'https://test.api.amadeus.com/v3/shopping/hotel-offers',
  HOTEL_IMAGES_URL: 'https://test.api.amadeus.com/v2/media/files/hotel/{hotelId}'
};

// Export individual constants for backward compatibility
export const {
  CLIENT_ID: AMADEUS_API_KEY,
  CLIENT_SECRET: AMADEUS_API_SECRET,
  TOKEN_URL: AMADEUS_TOKEN_URL,
  FLIGHT_SEARCH_URL: AMADEUS_FLIGHT_URL,
  FLIGHT_PRICING_URL: AMADEUS_FLIGHT_PRICING_URL,
  AIRPORT_FACILITIES_URL: AMADEUS_AIRPORT_FACILITIES_URL,
  FLIGHT_STATUS_URL: AMADEUS_FLIGHT_STATUS_URL,
  HOTEL_SEARCH_URL: AMADEUS_HOTEL_SEARCH_URL,
  HOTEL_OFFERS_URL: AMADEUS_HOTEL_OFFERS_URL,
  HOTEL_IMAGES_URL: AMADEUS_HOTEL_IMAGES_URL
} = AMADEUS_API;

// Groq API
export const GROQ_API_URL = "https://api.groq.com/openai/v1/chat/completions";
export const GROQ_API_KEY = "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";
export const GROQ_MODEL = "llama3-8b-8192";

// EmailJS Configuration
export const EMAIL_SERVICE_ID = "service_mlr8t7n";
export const EMAIL_TEMPLATE_ID = "template_y4ijfzb";
export const EMAIL_PUBLIC_KEY = "vddZ0SnOVJWHmjeWt";

// Weather API
export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5/weather";
export const WEATHER_API_KEY = "1febf06f270e95aa6b1b85e6c3a0a585";

// RapidAPI Configuration (used by multiple services)
export const RAPIDAPI = {
  KEY: 'e597091454msh2065fb8dd507016p10b2ffjsn269d0c5b5410',
  HOSTS: {
    SKYSCANNER: 'skyscanner89.p.rapidapi.com',
    BOOKING: 'booking-com15.p.rapidapi.com',
    RAILWAYS: 'indianrailways.p.rapidapi.com'
  }
};

// Export RapidAPI constants for backward compatibility
export const RAPIDAPI_KEY = RAPIDAPI.KEY;
export const RAPIDAPI_HOST = RAPIDAPI.HOSTS.SKYSCANNER; // Default to Skyscanner host

// Railways API Configuration
export const RAILWAYS_API_URL = "https://indianrailways.p.rapidapi.com/findTrains/";
export const RAILWAYS_API_HOST = RAPIDAPI.HOSTS.RAILWAYS;
export const RAILWAYS_API_KEY = RAPIDAPI.KEY;

// Booking.com API Configuration
export const BOOKING_API_BASE_URL = `https://${RAPIDAPI.HOSTS.BOOKING}/api/v1/hotels`;

// News API Configuration
export const NEWS_API_KEY = "d049a308121f4d5c8a0a4c3e7f4a8e1b";
export const NEWS_API_URL = 'https://newsapi.org/v2/everything';

// Aviation Stack API Configuration
export const AVIATION_STACK_API_KEY = 'f66e29c424eb7e674b5e9b406c026e2d';
export const AVIATION_STACK_API_URL = 'http://api.aviationstack.com/v1/flights';

// Skyscanner API Configuration
export const SKYSCANNER_API = {
  HOST: RAPIDAPI.HOSTS.SKYSCANNER,
  KEY: RAPIDAPI.KEY
};
